export default {
    model: '模型',
    orthophoto: '正射影像',
    obliquePhotography: '倾斜摄影',
    laserPointCloud: '激光点云',
    model3D: '3D模型',
    projectName: '项目名称',
    switchProject: '切换项目',
    newProject: '新建项目',
    modifyProject: '修改项目',
    modifyThisProject: '修改本项目',
    deleteThisProject: '删除本项目',
    isDelete: '确定删除吗？',
    dataName: '数据名称',
    creationTime: '创建时间',
    import: '导入{name}',
    mergeEdit: '合并编辑',
    projectNotes: '项目备注',
    lastUpdated: '最后更新时间',
    modifyDataInformation: '修改数据信息',
    modelList: '模型列表',
    rotationSettings: '旋转设置',
    rotateAroundAxis: '绕{name}轴旋转',
    translationSetting: '平移设置(单位：m)',
    translateAlongAxis: '沿{name}轴平移',
    modelReset: '模型重置',
    showTranslationAxis: '此处显示平移轴',
    showRotationAxis: '此处显示旋转轴',
    fileList: '文件列表',
    folderName: '文件夹名',
    numberFiles: '文件个数',
    size: '大小',
    dataSize: '数据大小',
    singleFile: '单个文件',
    folderWithPictures: '带贴图文件夹',
    mapPointSelection: '地图选点',
    heightMode: '高度模式',
    closeToTheSurface: '紧贴地表',
    relativeToTheSurface: '相对地表',
    state: '状态',
    altitude: '海拔高度',
    processing: '处理中',
    dataAnomaly: '数据异常',
    normal: '正常',
    mapView: '地图查看',
    modelEditing: '模型编辑',
    tip_PEDN: '请输入数据名称',
    tip_PEH: '请输入高度',
    tip_PUFTC: '请上传符合3D Tiles规范的文件!',
    tip_PUFT: '注意：请上传符合3D Tiles规范的文件，其他格式暂不支持。',
    tip_FCBE: '文件不能为空',
    tip_FEPR: '格式错误，请重新上传！',
    tip_uploadCanceled: '已取消上传',
    tip_TUFI: '上传文件夹缺少obj文件，请重新上传！',
    tip_TUFC: '上传文件夹只能有一个obj文件，请重新上传！',
}